import React, { Component } from 'react';
import Input from '../Input/Input';
import { CreateProps } from '../../types/utils/CreateProps';
import { BaseInputPropsWithoutChildren } from '../Input/BaseInput';

export type InputWrapperProps = CreateProps<
  {
    /** onChange callback for the datepickerinput */
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    /** Ref for input component  */
    inputRef?: React.RefObject<HTMLInputElement>;
  },
  BaseInputPropsWithoutChildren,
  'onChange' | 'iconName'
>;

// This internal custom input is a class component because it needs to support `ref` for react-day-picker
class DatePickerInputWrapper extends Component<InputWrapperProps> {
  private inputRef = this.props.inputRef ?? React.createRef<HTMLInputElement>();

  // To keep focus on input field after valid date is selected of filled to input
  focus() {
    this.inputRef.current?.focus();
  }

  // Currently allowed special chars are : "- _ . /" and the following special keys :
  allowedKeys = ['Tab', 'Backspace', 'Enter', 'ArrowLeft', 'ArrowRight', ' '];
  allowedChars = /^[0-9_./-]*$/;

  render() {
    return (
      <Input
        {...this.props}
        onKeyDown={(e: any) => {
          if (
            !this.allowedChars.test(e.key) &&
            !this.allowedKeys.includes(e.key)
          ) {
            e.preventDefault();
          }
          e.target.value = e.target.value.split(/-|_|\/|,/).join('.');
        }}
        label={this.props.label || ''}
        className={['datepicker-input-test', this.props.className]}
        onChange={(e) => this.props.onChange(e)}
        iconName="calendar"
        inputRef={this.inputRef}
        iconColor={this.props.errorText ? 'red600' : 'black'}
      />
    );
  }
}

export default DatePickerInputWrapper;
